import React from "react";
import { useI18n } from "../lib/i18n";
import { Globe } from "lucide-react";

export default function LangSwitcher({ compact = false }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      className="inline-flex items-center gap-1 p-1 rounded-full border border-white/10 bg-white/5"
      data-testid="lang-switcher"
    >
      {!compact && <Globe size={14} className="text-slate-400 ml-1.5" />}
      <button
        type="button"
        onClick={() => setLang("ca")}
        data-testid="lang-ca"
        className={`px-2.5 py-1 text-xs rounded-full transition-all ${
          lang === "ca"
            ? "bg-blue-500 text-white shadow-[0_0_12px_rgba(59,130,246,0.6)]"
            : "text-slate-400 hover:text-white"
        }`}
      >
        CA
      </button>
      <button
        type="button"
        onClick={() => setLang("es")}
        data-testid="lang-es"
        className={`px-2.5 py-1 text-xs rounded-full transition-all ${
          lang === "es"
            ? "bg-blue-500 text-white shadow-[0_0_12px_rgba(59,130,246,0.6)]"
            : "text-slate-400 hover:text-white"
        }`}
      >
        ES
      </button>
    </div>
  );
}
